export default __webpack_public_path__ + "static/media/edit.7507cd4d.svg";